<template>
    <small class="form-text">
        <slot/>
    </small>
</template>